import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VcsService } from '../../../services/vcs.service';
import { BaseComponent } from '../../../../components/base/base.component';
import { VcsAPIService } from '../../../services/vcs-api/vcs-api.service';
import { NotificationService } from '@wms/services';
import { WmsDialogComponent } from '../../../../components/wms-dialog/wms-dialog.component';
import { WmsDialogHeaderComponent } from '../../../../components/wms-dialog-header/wms-dialog-header.component';
import { WmsDialogBodyComponent } from '../../../../components/wms-dialog-body/wms-dialog-body.component';
import { WmsDialogFooterComponent } from '../../../../components/wms-dialog-footer/wms-dialog-footer.component';
import { WmsViewChangesTableComponent } from '../../wms-view-changes-table/wms-view-changes-table.component';
import { ICommit } from '@wms/app/vcs/interface/commit';


@Component({
  selector: 'wms-vcs-view-commit-changes-dialog',
  templateUrl: './wms-vcs-view-commit-changes-dialog.component.html',
  styleUrls: ['./wms-vcs-view-commit-changes-dialog.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsViewChangesTableComponent
  ],
})
export class WmsVcsViewCommitChangesDialogComponent extends BaseComponent {
  @Input() selectedCommit:ICommit
  public vcsService: VcsService;
  private vcsAPIService: VcsAPIService;
  private notificationService: NotificationService;

  constructor() {
    super();
    this.vcsService = inject(VcsService);
    this.vcsAPIService = inject(VcsAPIService);
    this.notificationService = inject(NotificationService);
  }

 
}